/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flagship_Onboarding_Glider_Home_LabelInputs */

const en_flagship_onboarding_glider_home_label = /** @type {(inputs: Flagship_Onboarding_Glider_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider home`)
};

const de_flagship_onboarding_glider_home_label = /** @type {(inputs: Flagship_Onboarding_Glider_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider-Startseite`)
};

const pt_br2_flagship_onboarding_glider_home_label = /** @type {(inputs: Flagship_Onboarding_Glider_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página inicial da Glider`)
};

const tr_flagship_onboarding_glider_home_label = /** @type {(inputs: Flagship_Onboarding_Glider_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider ana sayfası`)
};

const zh_cn2_flagship_onboarding_glider_home_label = /** @type {(inputs: Flagship_Onboarding_Glider_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider 首页`)
};

const zh_hk2_flagship_onboarding_glider_home_label = /** @type {(inputs: Flagship_Onboarding_Glider_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider 主頁`)
};

const ko_kr2_flagship_onboarding_glider_home_label = /** @type {(inputs: Flagship_Onboarding_Glider_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider 홈`)
};

const ru_ru2_flagship_onboarding_glider_home_label = /** @type {(inputs: Flagship_Onboarding_Glider_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главная Glider`)
};

const es_419_flagship_onboarding_glider_home_label = /** @type {(inputs: Flagship_Onboarding_Glider_Home_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio de Glider`)
};

/**
* | output |
* | --- |
* | "Glider home" |
*
* @param {Flagship_Onboarding_Glider_Home_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const flagship_onboarding_glider_home_label = /** @type {((inputs?: Flagship_Onboarding_Glider_Home_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flagship_Onboarding_Glider_Home_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flagship_onboarding_glider_home_label(inputs)
	if (locale === "de") return de_flagship_onboarding_glider_home_label(inputs)
	if (locale === "pt-BR") return pt_br2_flagship_onboarding_glider_home_label(inputs)
	if (locale === "tr") return tr_flagship_onboarding_glider_home_label(inputs)
	if (locale === "zh-CN") return zh_cn2_flagship_onboarding_glider_home_label(inputs)
	if (locale === "zh-HK") return zh_hk2_flagship_onboarding_glider_home_label(inputs)
	if (locale === "ko-KR") return ko_kr2_flagship_onboarding_glider_home_label(inputs)
	if (locale === "ru-RU") return ru_ru2_flagship_onboarding_glider_home_label(inputs)
	return es_419_flagship_onboarding_glider_home_label(inputs)
});